import { render } from "./weekRangePicker.vue?vue&type=template&id=144b8c2f&ts=true"
import script from "./weekRangePicker.vue?vue&type=script&lang=ts"
export * from "./weekRangePicker.vue?vue&type=script&lang=ts"

import exportComponent from "/app/ViewpointPBIEmbedded/ViewpointPBIEmbedded.BFF/ClientApp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__